import { createSlice } from "@reduxjs/toolkit";
import { getBanner, submitBanner, deleteBanner } from "./Utils/bannerUtils";
import Swal from 'sweetalert2';

const initialState = {
    filters: {
        "filter[id]": "",
        "filter[title]": "",
        "sort": "-id",
        "page": "",
    },
    banners: [],
    pagination: {},
    loading: false,
    error: null,
    currentBanner: {  // Ini buat menyimpan data form yang lagi aktif
        id: null,
        title: "",
        link: "",
        photo: null,
    }
};


const BannerSlice = createSlice({
    name: "Banner",
    initialState,
    reducers: {
        setFormData: (state, action) => {
            state.currentBanner = { ...state.currentBanner, ...action.payload };
        },
        resetFormData: (state) => {
            state.currentBanner = initialState.currentBanner;
        },
        setFilters: (state, action) => {
            state.filters = { ...state.filters, ...action.payload };
        }
    },
    extraReducers: (builder) => {
        builder
            // Handle getBanner
            .addCase(getBanner.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getBanner.fulfilled, (state, action) => {
                state.loading = false;
                state.banners = action.payload.data;
                state.pagination = action.payload.pagination;
            })
            .addCase(getBanner.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            // Handle submitBanner (update atau tambah branch)
            .addCase(submitBanner.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(submitBanner.fulfilled, (state, action) => {
                state.loading = false;
                Swal.fire({
                    icon: 'success',
                    title: 'Success',
                    text: 'Data Kategori Berhasil Disimpan',
                    toast: true,
                    position: 'center',
                    showConfirmButton: false,
                    timer: 2000,
                    timerProgressBar: true,
                });

                // Kalau data baru, tambah ke daftar
                if (!state.banners.find(Banner => Banner.id === action.payload.id)) {
                    state.banners.push(action.payload);
                } else {
                    // Kalau update, replace data lama
                    state.banners = state.banners.map(Banner =>
                        Banner.id === action.payload.id ? action.payload : Banner
                    );
                }

                // Reset form setelah simpan
                state.currentBanner = initialState.currentBanner;
            })
            .addCase(submitBanner.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            // Handle deleteBanner
            .addCase(deleteBanner.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(deleteBanner.fulfilled, (state, action) => {
                state.loading = false;
                state.banners = state.banners.filter(Banner => Banner.id !== action.payload.id);
            })
            .addCase(deleteBanner.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    }
});

export const { setFormData, resetFormData, setFilters } = BannerSlice.actions;
export default BannerSlice.reducer;